webpackJsonp([19],{

/***/ 256:
/***/ (function(module, exports) {

// Horizontal scroll navigation
// ------------------------------------------
var scrollPrev = document.querySelector('.page-heading__sub-navigation__prev');
var scrollNext = document.querySelector('.page-heading__sub-navigation__next');
var subNavigationBar = document.querySelector('.page-heading__sub-navigation');
var subNavigation = document.querySelector('.page-heading__sub-navigation__holder');
var subNavigationList = document.querySelector('.page-heading__sub-navigation__list'); // if subnavigation exists

if (subNavigation) {
  scrollNavigation();
  window.addEventListener('resize', function () {
    scrollNavigation();
  }, true);
}

function scrollNavigation() {
  var subNavigationListWidth = subNavigationList.getBoundingClientRect().width;
  var windowWidth = window.innerWidth;
  var valueOverflow = subNavigationListWidth - windowWidth; // if subnavigation is equal or larger than window innerWidth

  if (subNavigationListWidth >= windowWidth) {
    var scrollCount = 0;
    subNavigationBar.classList.add('is--overflow');

    if (scrollCount === 0) {
      scrollPrev.classList.add('not--active');
    } // on touch event


    subNavigationList.addEventListener('touchend', function () {
      setTimeout(function () {
        scrollCount = subNavigation.scrollLeft;

        if (scrollCount >= valueOverflow) {
          scrollNext.classList.add('not--active');
        }

        if (scrollCount < valueOverflow) {
          scrollNext.classList.remove('not--active');
        }

        if (scrollCount <= 0) {
          scrollPrev.classList.add('not--active');
        }

        if (scrollCount > 0) {
          scrollPrev.classList.remove('not--active');
        }
      }, 250);
    }, false); // on click next

    scrollNext.addEventListener('click', function () {
      scrollCount = subNavigation.scrollLeft + windowWidth / 1.5;
      subNavigation.scrollTo({
        left: subNavigation.scrollLeft + windowWidth / 1.5,
        behavior: 'smooth'
      });

      if (scrollCount >= valueOverflow) {
        scrollNext.classList.add('not--active');
      }

      if (scrollCount < valueOverflow) {
        scrollNext.classList.remove('not--active');
      }

      if (scrollCount <= 0) {
        scrollPrev.classList.add('not--active');
      }

      if (scrollCount > 0) {
        scrollPrev.classList.remove('not--active');
      }
    }, false); // on click prev

    scrollPrev.addEventListener('click', function () {
      scrollCount = subNavigation.scrollLeft - windowWidth / 1.5;
      subNavigation.scrollTo({
        left: subNavigation.scrollLeft - windowWidth / 1.5,
        behavior: 'smooth'
      });

      if (scrollCount >= valueOverflow) {
        scrollNext.classList.add('not--active');
      }

      if (scrollCount < valueOverflow) {
        scrollNext.classList.remove('not--active');
      }

      if (scrollCount <= 0) {
        scrollPrev.classList.add('not--active');
      }

      if (scrollCount > 0) {
        scrollPrev.classList.remove('not--active');
      }
    }, false);
  } else {
    subNavigationBar.classList.remove('is--overflow');
  }
}

/***/ })

});


// WEBPACK FOOTER //
// build/19.b6595c762abc6aa41905.web.chunk.js